import { useMemo } from 'react';
import { getWelcomePagePhotoUrl } from '@shared/utils/getWelcomePagePhotoUrl';
import { useIsFeatureEnabled } from '@shared/core/featureFlags';
import type { SupportedHeaderPhotoLayoutSchema } from '@shared/types/WebsiteHeaderSettings.types';
import type { GuestSiteEvent } from '../layout.types';
import { EventType } from '@graphql/generated-base';

type UseWelcomePagePhotoUrlArgs = Readonly<{
  event: GuestSiteEvent;
  headerPhoto: SupportedHeaderPhotoLayoutSchema | undefined;
}>;

export const useWelcomePagePhotoUrl = ({ event, headerPhoto }: UseWelcomePagePhotoUrlArgs): string | null => {
  const [isEventPhotoV2UrlMigrationEnabled] = useIsFeatureEnabled('eventPhotoV2UrlMigration');
  const eventPhotoV2Url = event.photoV2Url;
  const eventPhotoUrl = event.photo?.url;
  const isGeneralEvent = event.info.eventType === EventType.general;

  return useMemo(
    () => getWelcomePagePhotoUrl({ dataJSON: headerPhoto, isEventPhotoV2UrlMigrationEnabled, eventPhotoV2Url, eventPhotoUrl, isGeneralEvent }),
    [headerPhoto, isEventPhotoV2UrlMigrationEnabled, eventPhotoV2Url, eventPhotoUrl, isGeneralEvent],
  );
};
